import React from "react";

const tickerItems = [
  "Artists",
  "Performers",
  "Entertainers",
  "Actors",
  "Directors",
  "Musicians",
  "Writers",
  "Authors",
  "Comedians",
  "Singers",
  "Dancers",
  "Models",
  "Stunt Performers",
  "Stage Managers",
  "Animators",
  "Instrumentalists",
  "Vocalists",
  "Talent Reps",
  "Casting Directors",
  "Filmmakers",
  "Documentarians",
  "Fashion Designers",
  "Costumers",
  "Producers",
  "Camera Crew",
  "Media Professionals",
  "Production Professionals",
  "Creatives On Stage",
  "Off Stage",
  "On Screen",
  "Behind the Scenes",
  "Theaters",
  "Comedy Clubs",
  "Art Galleries",
  "Museums",
  "Arts Organizations",
  "Studios",
  "Schools",
  "Cultural Institutions",
];

const ArtistTickerSection = () => {
  // Duplicate for seamless infinite loop
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          The professional home for everyone in the arts.
        </h2>
        <p className="text-lg md:text-xl text-[#30D5C8] font-medium mb-1">
          All in one place. All verified.
        </p>
      </div>

      {/* Ticker */}
      <div className="overflow-hidden w-full">
        <style>{`
          @keyframes ticker {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .ticker-track {
            display: flex;
            width: max-content;
            animation: ticker 60s linear infinite;
          }
          .ticker-track:hover {
            animation-play-state: paused;
          }
        `}</style>
        <div className="ticker-track">
          {doubled.map((item, i) => (
            <span key={i} className="inline-flex items-center whitespace-nowrap">
              <span className="text-base md:text-lg font-semibold text-gray-700">{item}</span>
              <span className="mx-4 text-[#30D5C8] text-xl font-bold leading-none">·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArtistTickerSection;
